import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 440,
  parentId: 400,
  name: "Model",
  label: "Model",
  path: "model",
  element: Element,
  user: true,
  admin: false,
  hidden: false,
};

export default route;
